import { render, staticRenderFns } from "./LeaseContractTermsTabScreen.vue?vue&type=template&id=741c2d08&"
import script from "./LeaseContractTermsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseContractTermsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports